/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/*
 * @format
 */
import { makeAsyncAction } from 'ui-permit/shared-components/utils/async';
import {
    FETCH_LOTTERIES,
    FETCH_LOTTERY,
    FETCH_LOTTERY_ISSUANCE,
    CANCEL_LOTTERY_ISSUANCE,
    ACCEPT_LOTTERY_ISSUANCE,
} from '../constants/actions';

import * as api from '../api';

export const fetchLotteries = makeAsyncAction(
    FETCH_LOTTERIES,
    (permitId) => async () => api.fetchLotteriesContent(permitId),
    'payload'
);
export const fetchLottery = makeAsyncAction(
    FETCH_LOTTERY,
    (permitId, lotteryId) => async () => api.fetchLottery(permitId, lotteryId),
    'payload'
);
export const fetchLotteryIssuance = makeAsyncAction(
    FETCH_LOTTERY_ISSUANCE,
    (permitId, issuanceId) => async () => api.fetchLotteryIssuance(permitId, issuanceId),
    'payload'
);
export const cancelLotteryIssuance = makeAsyncAction(
    CANCEL_LOTTERY_ISSUANCE,
    (permitId, issuanceId, useNewMuxPath) => async () =>
        api.cancelLotteryIssuance(permitId, issuanceId, useNewMuxPath),
    'payload'
);
export const acceptLotteryIssuance = makeAsyncAction(
    ACCEPT_LOTTERY_ISSUANCE,
    (permitId, issuanceId, useNewMuxPath) => async () =>
        api.acceptWinningLotteryIssuance(permitId, issuanceId, useNewMuxPath),
    'payload'
);
